/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".fill[_ngcontent-%COMP%]{color:#bfbfbf}span[_ngcontent-%COMP%]{margin-right:5px}"];
export { styles as styles };
